import { schema } from 'normalizr';
import people from 'schemas/people';
import season from 'schemas/season';

const movie = new schema.Entity('movie', {
  people: [people],
  season_list: [season],
});

export default movie;
